/**
 * Created by zhouxuwang on 2021/12/10
 */

export default function tabsSchemaHandle (props) {
  return {
    _type: 'tabs',
    viewComponentName: 'tabs-render',
    props: props.name
    // apiName
  }
}

export const tabsProps = {
  // tabs类型  是普通类型还是卡片类型
  type: {
    type: String,
    default: 'ordinary'
  },
  // 如果是普通类型的tabs的话是有title
  title: {
    type: String,
    default: ''
  },
  // 切换到了哪个tabs v-model
  activeTab: {
    type: String,
    default: ''
  },
  // 是否要隐藏tabs
  hideTabs: {  
    type: Boolean,
    default: false
  },
  // 是否显示下边框
  showBottomBorder: {
    type: Boolean,
    default: false
  },
  // 是否需要在路由内添加tabs
  isHaveTab: {
    type: Boolean,
    default: false
  },
  changeTabReserveQuery: {
    type: Boolean,
    default: false
  }
}
